import { Component } from '@angular/core';

@Component({
    selector: 'app-blank-layout',
    template: `
    <router-outlet></router-outlet>
  `,
    standalone: false
})
export class BlankLayoutComponent {}